// Modern Footer Component
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FiMail, 
  FiArrowUp,
  FiClock,
  FiDownload
} from 'react-icons/fi';
import { SOCIAL_LINKS } from '../../../constants/content';
import styles from './Footer.module.css';


const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className="container">
          <div className={styles.footerGrid}>
            {/* Company Info */}
            <div className={styles.footerColumn}>
              <div className={styles.footerLogos}>
                <div className={styles.mainLogo}>
                  <img src="/images/logowhite.webp" alt="Shankar Multimedia" loading="lazy" decoding="async" />
                </div>
                <div className={styles.certificationLogos}>
                  <img src="/images/img2/35 LOGO.webp" alt="36 years Excellence" className={styles.certLogo} loading="lazy" decoding="async" />
                  <img src="/images/img2/wwe.webp" alt="WWE Certification" className={styles.certLogo} loading="lazy" decoding="async" />
                  <img src="/images/img2/msme.webp" alt="msme Certification" className={styles.certLogo} loading="lazy" decoding="async" />
                </div>
              </div>
              <p className={styles.footerDescription}>
                With over 36 years of excellence, Shankar Multimedia is Mumbai’s leading and top-rated, government-recognized animation institute, offering courses in Graphic Design, UI/UX, Motion Graphic Design, Video Editing, VFX, 3D Animation, Digital Marketing, and Multimedia Animation. We are an ISO 9001:2015 certified institute for IT and multimedia animation training.
              </p>
              <div className={styles.socialLinks}>
                <a href={SOCIAL_LINKS.facebook} className={styles.socialLink} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <img src="/images/img2/fb.webp" alt="Facebook" loading="lazy" decoding="async" />
                </a>
                <a href={SOCIAL_LINKS.instagram} className={styles.socialLink} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <img src="/images/img2/int.webp" alt="Instagram" loading="lazy" decoding="async" />
                </a>
                
                <a href={SOCIAL_LINKS.youtube} className={styles.socialLink} aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                  <img src="/images/img2/yt.webp" alt="YouTube" loading="lazy" decoding="async" />
                </a>

                <a href={SOCIAL_LINKS.threads} className={styles.socialLink} aria-label="Threads" target="_blank" rel="noopener noreferrer">
                  <img src="/images/img2/threads.webp" alt="Threads" loading="lazy" decoding="async" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerTitle}>Quick Links</h3>
              <ul className={styles.footerLinks}>
                <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
                <li><Link to="/students-work" onClick={scrollToTop}>Students Work</Link></li>
                <li><Link to="/online-learning" onClick={scrollToTop}>Online Programs</Link></li>
                <li><Link to="/placements" onClick={scrollToTop}>Placements</Link></li>
                <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
                <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
                <li><Link to="/terms-conditions" onClick={scrollToTop}>Terms and Conditions</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerTitle}>Get in Touch</h3>
              <div className={styles.contactInfo}>
                <div className={styles.contactItem}>
                  <FiMail />    
                  <a
                    href="mailto:info@shankarmultimedia.com"
                    className={styles.highlight}
                    aria-label="Email Shankar Multimedia"
                  >
                    info@shankarmultimedia.com
                  </a>
                </div>
                <div className={styles.contactItem}>
                  <FiClock />
                  <span>Monday To Saturday 8am To 9pm | Sunday 9am To 2pm</span>
                </div>
              </div>
              <br></br>
              <h3 className={styles.footerTitle}>Institute Centers</h3>
              <div className={styles.contactInfo}>
                <ul className={styles.footerLinks}>
                  <li className={styles.centerItem}>
                    <a href="https://maps.google.com/?q=Shankar+Multimedia+Goregaon+Mumbai" target="_blank" rel="noopener noreferrer">Goregaon</a>
                    <a href="tel:+919819508524" className={styles.centerPhone}>+91 98195 08524</a>
                  </li>
                  <li className={styles.centerItem}>
                    <a href="https://maps.google.com/?q=Shankar+Multimedia+Malad+Mumbai" target="_blank" rel="noopener noreferrer">Malad</a>
                    <a href="tel:+919223439986" className={styles.centerPhone}>+91 92234 39986</a>
                  </li>
                  <li className={styles.centerItem}>
                    <a href="https://maps.google.com/?q=Shankar+Multimedia+Santacruz+Mumbai" target="_blank" rel="noopener noreferrer">Santacruz</a>
                    <a href="tel:+917304157986" className={styles.centerPhone}>+91 73041 57986</a>
                  </li>
                  <li className={styles.centerItem}>
                    <a href="https://maps.google.com/?q=Shankar+Multimedia+Mulund+Mumbai" target="_blank" rel="noopener noreferrer">Mulund</a>
                    <a href="tel:+919619177392" className={styles.centerPhone}>+91 96191 77392</a>
                  </li>
                  <li className={styles.centerItem}>
                    <a href="https://maps.google.com/?q=Shankar+Multimedia+Nalasopara+Mumbai" target="_blank" rel="noopener noreferrer">Nalasopara</a>
                    <a href="tel:+917021382816" className={styles.centerPhone}>+91 70213 82816</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div className="container">
          <h3 className={styles.footerTitle}><Link to="/online-learning" onClick={scrollToTop}>Online Programs Now Available</Link></h3>
          <div className={styles.footerBottomContent}>
            <p className={styles.footerLinks}>
              <Link to="/courses/advanced-graphic-and-uiux-design" onClick={scrollToTop}>Graphic and UI/UX Design Course in Mumbai</Link> | <Link to="/courses/advanced-motion-graphic-and-video-editing" onClick={scrollToTop}>Motion Graphic and Video Editing Course in Mumbai</Link> | <Link to="/courses/advanced-3d-animation-and-modeling" onClick={scrollToTop}>3D Animation and Modeling Course in Mumbai</Link> | <Link to="/courses/advanced-interior-design" onClick={scrollToTop}>Interior Design Course in Mumbai</Link> | <Link to="/courses/advanced-3d-animation-and-vfx" onClick={scrollToTop}>3D Animation and VFX Course in Mumbai</Link> | <Link to="/courses/advanced-web-design-and-development" onClick={scrollToTop}>Full Stack Web Development Course in Mumbai</Link> | <Link to="/courses/advanced-digital-marketing" onClick={scrollToTop}>Digital Marketing Course in Mumbai</Link> | <Link to="/courses/advanced-multimedia-animation-and-vfx" onClick={scrollToTop}>Multimedia Animation and VFX Course in Mumbai</Link> | <Link to="/online-learning" onClick={scrollToTop}>Online Programs</Link>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div className="container">
          <div className={styles.footerBottomContent}>
            <p className={styles.copyright}>
              Shankar Multimedia. All Rights Reserved ©{new Date().getFullYear()}
            </p>
            
          </div>
        </div>
      </div>

      {/* Download Brochure Button */}
      <motion.a
        href="/Shankar Multimedia Brochure.pdf"
        download="Shankar Multimedia Brochure.pdf"
        className={styles.downloadBrochure}
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        whileHover={{ scale: 1.05 }} 
        whileTap={{ scale: 0.95 }} 
        aria-label="Download Brochure"
      >
        <FiDownload /> 
        <span>Download Brochure</span>
      </motion.a>
    </footer>
  );
};

export default Footer;